<!-- Do not change this file. -->

<template>
  <div class="navbar navbar-dark bg-dark showAboveFullScreenComponents">
    <div class="container-fluid">
      <div class="navbar-brand d-flex">
        <img
          src="@/assets/logo-dark.svg"
          alt="Oregon State University Logo"
          height="30"
          class="d-inline-flex align-top me-3 pe-3 border-end"
        />
        <div class="title me-3 fw-bold">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

export default {
  name: "Header",
  props: {
    title: {
      type: String,
      default: process.env.VUE_APP_COURSE
    },
    subtitle: {
      type: String,
      default: process.env.VUE_APP_TITLE
    }
  }
};
</script>
